import logo from './logo.svg';
import './App.css';

import React from 'react'

import Routes from './routes'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        {/* <img src={logo} className="App-logo" alt="logo" />
        <p>Cool text bro</p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a> */}
        <h1>Testing</h1>
      </header>
      <Routes />
    </div>
  );
}

export default App;
